import * as yup from 'yup';

import { nameApplicant, email, description } from '@core/validation';

const title = yup.string().required('Необходимо указать заголовок');
const address = yup.string().notRequired();
const personalAccount = yup
  .string()
  .matches(/^\d+$/, 'Укажите только цифры')
  .required('Необходимо указать ваш лицевой счет');

export const FormSchema = yup.object({
  nameApplicant: nameApplicant.required('Необходимо указать ваше имя'),
  email: email.required('Необходимо указать ваш адрес электронной почты'),
  address,
  title,
  text: description.required('Необходимо указать причину'),
  personalAccount,
  personalDataRegistrationAgreement: yup.boolean().oneOf([true]),
});

export type FormProps = yup.InferType<typeof FormSchema>;
